
/* eslint vue/no-mutating-props: 0 */
export default {
    inheritAttrs: false,
    props: {
        /**
         * Label for the input
         */
        label: {
            type: String,
            default: '',
        },
        /**
         * A form object field
         */
        field: {
            type: Object,
            required: true,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            id: '',
        };
    },
    mounted() {
        this.id = `_${Math.random().toString(36).substr(2, 9)}`;
    },
};

